export default __webpack_public_path__ + "static/media/video-sdg-2.72a49957.mp4";